module.exports = __webpack_public_path__ + "img/project-01.fde92399.jpg";